import React, { useEffect, useState } from 'react';
import { processLogAndRedirectWithoutAPI } from '../logService';
import { registerQRCodeUsage } from '../services/api';

function Step1() {
  const [showLoading, setShowLoading] = useState(false);

  // QR 코드 스캔 이벤트 처리
  const handleQRCodeScan = async (sessionId, deviceId = null) => {
    try {
      if (!sessionId) {
        console.error('세션 ID가 없습니다. URL 파라미터에서 sessionId를 확인해주세요.');
        return;
      }
      
      await registerQRCodeUsage(sessionId, deviceId);
      console.log('QR 코드 사용 통계가 성공적으로 등록되었습니다.');
    } catch (error) {
      console.error('QR 코드 사용 통계 등록 중 오류 발생:', error);
    }
  };


  useEffect(() => {
    const handleLoadingStart = () => {
      setShowLoading(true);
    };

    // URL 파라미터에서 sessionId와 deviceId 추출
    const urlParams = new URLSearchParams(window.location.search);
    const sessionId = urlParams.get('sessionId');
    const deviceId = urlParams.get('deviceId');

    // QR 코드 스캔 이벤트 시뮬레이션 (실제 구현에서는 QR 스캐너에서 호출)
    const simulateQRScan = () => {
      handleQRCodeScan(sessionId, deviceId);
    };

    // 컴포넌트 마운트 시 QR 스캔 이벤트 발생
    simulateQRScan();

    // 로그 처리 및 리다이렉트 (API 호출 없이 리다이렉트만)
    processLogAndRedirectWithoutAPI(handleLoadingStart, 'step1', { sessionId, deviceId });
  }, []);

  // 조건부 로딩 화면 표시
  if (showLoading) {
    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: '#f8f9fa',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
      }}>
        <div style={{
          textAlign: 'center',
          color: '#6c757d'
        }}>
          <div style={{
            width: '40px',
            height: '40px',
            border: '3px solid #e9ecef',
            borderTop: '3px solid #007bff',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 16px'
          }}></div>
          <p style={{ margin: 0, fontSize: '14px' }}>Loading...</p>
        </div>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  // 로딩 화면이 표시되지 않으면 아무것도 렌더링하지 않음
  return null;
}

export default Step1;
